import React, { useEffect, useState } from "react";
import { deleteItem, fetchData } from "../utils/apiUtils";
import DeleteModel from "../Components/DeleteModel";
import { ActionButton } from "../helper/ImageFormat";
import CustomPagination from "../helper/Pagination";
import Spinner from "../Components/spinner";
import Breadcrumb from "../helper/Breadcrumb";
import PerPageSelect from "../Components/PerPageSelect";
import TableSearch from "../Components/TableSearch";
import dateformate from "../helper/DateFormate";
import { useNavigate } from "react-router-dom";

const ProductsInquiry = () => {
  const navigator = useNavigate();
  const [loading, setLoading] = useState(true);
  const [inquiryData, setInquiryData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
 const [search, setSearch] = useState("");
 const [perPage, setPerPage] = useState(10);


  const totalPages = Math.ceil(totalCount / perPage);

  const fetchinquiryData = async (page = 1, searchQuery = "") => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
      search: searchQuery,
    };
    await fetchData(
      "inquiry-pagination",
      requestData,
      setInquiryData,
      setTotalCount,
      setCurrentPage,
      setLoading
    );
  };

 
   useEffect(() => {
    const delay = search ? 500 : 0;
    const handler = setTimeout(() => {
     fetchinquiryData(1, search);
    }, delay);
  
    return () => clearTimeout(handler);
   }, [search, perPage]);

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("inquiry", deleteItemId?.id, fetchinquiryData);
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (err) {
      throw err;
    } finally {
      setIsDeleting(false);
    }
  };

  // const confirmDelete = async () => {
  //   await deleteItem("inquiry", deleteItemId, fetchinquiryData);
  //   setDeleteItemId(null);
  //   setDeleteModalOpen(false);
  // };

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchinquiryData(page);
    }
  };
 


  
 const handleEditClick = (item) => {
  navigator("/product-inquiry-detail", {
   state: item,
  });
 };

  const Tableheader = ["#", "SKU", "Email", "Mobile No.","Updated At", "Action"];
   const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Products Inquiry", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="custom-page-title">Products Inquiry</h3>
           <Breadcrumb items={breadcrumbdata} />
        </div>

             <div
     className="d-flex justify-content-between mb-2"
     style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
    >
      <PerPageSelect value={perPage} onChange={setPerPage}/>

     <div style={{ display: "flex", gap: "20px" }}>
     <TableSearch value={search} onChange={setSearch} />
     </div>
    </div>
        <div className="row">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive ">
                  <table
                    className=" custom-table table table-striped"
                    id="collectiontable"
                  >
                    <thead>
                      <tr>
                        {Tableheader &&
                          Tableheader.length > 0 &&
                          Tableheader.map((item, index) => <th key={index}>{item}</th>)}
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : inquiryData.length > 0 ? (inquiryData.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.Catalogue === null ? item?.Product?.sku : item?.Catalogue?.cat_code}</td>
                            <td>
                                <i className="fa-regular fa-envelope" style={{ marginRight: "5px", color: "#f44336" }}></i>
                              {item.email}</td>
                            <td>
                 <i className="fa-solid fa-phone" style={{ marginRight: "5px", color: "#4caf50" }}></i>

                              {item.mobile_number}
                              </td>
                        <td>
                          {dateformate(item.updatedAt)}
</td>

                            <td className="text-center">
                              <ActionButton
                                data={item}
                                handleEditClick={handleEditClick}
                                handleDelete={handleDelete}

                                module={"inquiry details"}
                              />
                            </td>
                          </tr>
                        );
                      })
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            <h5>No data found.</h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {inquiryData.length > 0 && (
                  <div>
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <DeleteModel
        deleteModalOpen={deleteModalOpen}
        setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
        onConfirm={confirmDelete}
        itemName="inquiry"
        isDeleting={isDeleting}
      />
    </>
  );
};

export default ProductsInquiry;
